import { render, staticRenderFns } from "./FAQList.vue?vue&type=template&id=07f8b9f3&scoped=true"
import script from "./FAQList.vue?vue&type=script&lang=js"
export * from "./FAQList.vue?vue&type=script&lang=js"
import style0 from "./FAQList.vue?vue&type=style&index=0&id=07f8b9f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8b9f3",
  null
  
)

export default component.exports